import { render, staticRenderFns } from "./EditStocksForm.vue?vue&type=template&id=39b76d46&scoped=true"
import script from "./EditStocksForm.vue?vue&type=script&lang=js"
export * from "./EditStocksForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b76d46",
  null
  
)

export default component.exports